module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes,
    attrs: {
      "role": "tree",
      "onselectstart": "return false"
    }
  }, [_c('ul', {
    class: _vm.containerClasses,
    attrs: {
      "role": "group"
    }
  }, _vm._l((_vm.data), function(child, index) {
    return _c('tree-item', {
      key: index,
      attrs: {
        "data": child,
        "text-field-name": _vm.textFieldName,
        "value-field-name": _vm.valueFieldName,
        "children-field-name": _vm.childrenFieldName,
        "item-events": _vm.itemEvents,
        "whole-row": _vm.wholeRow,
        "show-checkbox": _vm.showCheckbox,
        "allow-transition": _vm.allowTransition,
        "height": _vm.sizeHeight,
        "parent-item": _vm.data,
        "draggable": _vm.draggable,
        "drag-over-background-color": _vm.dragOverBackgroundColor,
        "on-item-click": _vm.onItemClick,
        "on-item-toggle": _vm.onItemToggle,
        "on-item-drag-start": _vm.onItemDragStart,
        "on-item-drag-end": _vm.onItemDragEnd,
        "on-item-drop": _vm.onItemDrop,
        "klass": index === _vm.data.length - 1 ? 'tree-last' : ''
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(_) {
          return [_vm._t("default", [(!_.model.loading) ? _c('i', {
            class: _.vm.themeIconClasses,
            attrs: {
              "role": "presentation"
            }
          }) : _vm._e(), _vm._v(" "), _c('span', {
            domProps: {
              "innerHTML": _vm._s(_.model[_vm.textFieldName])
            }
          })], {
            vm: _.vm,
            model: _.model
          })]
        }
      }])
    })
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7fbf202c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/tree.vue
// module id = 9
// module chunks = 0